<template>
	<div class="emailRequest row">
		<p class="col-12">{{text}}</p>
		<div class="col-12">
			<ButtonWithLoading
				class="mt-2"
				:state="submitState"
				:text="buttontext"
				loadingText="Requesting"
				successText="Requested"
				failureText="Error Requesting"
				@click.native="request"
			></ButtonWithLoading>
		</div>
		<div class="errorBox invalid-feedback" v-if="errorMessage != ''" >
			<span>{{errorMessage}}</span>
		</div>
	</div>
</template>

<script>
import ButtonWithLoading from "@/components/buttonWithLoading";
import { postMemberBizRequest } from "@/network/contactRequests";
import {fetchUserDetails } from "@/network/userRequests";
export default {
	name: 'EmailRequest',
	props:['text', 'action', 'buttontext'],
	components: {
		ButtonWithLoading
	},
	data() {
		return {
			submitState: null,
			user: null,
			errorMessage: null,
		}
	},
	created() {
		fetchUserDetails(userDetails => {
			this.user = userDetails;
		});
	},
	methods: {
		request() {
			this.submitState = "loading";
			let email = this.user.member_details.email;
			let name = this.user.member_details.given_name;
			postMemberBizRequest({email, name}, 
				() => {
					this.submitState = "success";
					setTimeout(() => {
						this.submitState = null;
						this.errorMessage = "";
					}, 5000);
				},
				(error) => {
					this.errorMessage = error.message || "Error with request";
					this.submitState = "failure";
					setTimeout(() => {
						this.submitState = null
					}, 3000);
				}
			);
		}
	}
}
</script>

<style lang="scss" scoped>
	.emailRequest, .errorBox {
		text-align: center;
	}

	.reqForm {
		margin-bottom: 1em;
	}

</style>
